import styled from 'styled-components';
import { tokens } from '@welbe/web-design-system';

export const Container = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	margin-top: 42px;
	margin-bottom: 36px;
`;

export const ContainerTitles = styled.div`
	h2 {
		color: ${tokens.color_primary};
		font-weight: 600;
		font-size: 20px;
	}

	h3 {
		padding: 15px 0;
		color: ${tokens.color_gray_dark};
		font-weight: 500;
		font-size: 18px;
	}
`;

export const ContainerDates = styled.div`
	padding: 0 15px;
	min-width: 290px;
	display: flex;
	flex-direction: column;
	gap: 14px;
`;

export const OpenModal = styled.button`
	cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

	input {
		cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
		background: ${tokens.color_gray_light};
		font-size: 14px;
		color: #64778f;
		font-weight: 600;
	}

	svg {
		cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
	}
`;

export const ContainerCalendars = styled.div`
	display: flex;
	justify-content: center;
	gap: 24px;
`;

export const ContainerSkeletonDate = styled.div`
	cursor: wait;
	display: flex;
	flex-direction: column;
	gap: 5px;
`;

export const ContainerSkeletons = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 24px;
	width: 520px;
`;
